import React, { useState, useEffect, useRef } from 'react';
import { Link, useLocation } from 'react-router-dom';
import logo from '../../assets/logo.png';

function Header() {
  const location = useLocation();
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
  const navRef = useRef(null);
  const hamburgerRef = useRef(null);

  const isActive = (path) => {
    return location.pathname === path ? 'active' : '';
  };

  const handleNavClick = () => {
    setMobileMenuOpen(false);
  };

  const toggleMobileMenu = () => {
    setMobileMenuOpen(!mobileMenuOpen);
  };

  // Close menu when clicking outside
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        mobileMenuOpen &&
        navRef.current &&
        hamburgerRef.current &&
        !navRef.current.contains(event.target) &&
        !hamburgerRef.current.contains(event.target)
      ) {
        setMobileMenuOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    document.addEventListener('touchstart', handleClickOutside);

    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
      document.removeEventListener('touchstart', handleClickOutside);
    };
  }, [mobileMenuOpen]);

  // Close menu on route change (extra safety)
  useEffect(() => {
    setMobileMenuOpen(false);
  }, [location.pathname]);

  return (
    <header>
      <div className="header-wrapper">
        <button 
          ref={hamburgerRef}
          className="hamburger-menu" 
          onClick={toggleMobileMenu}
          aria-label="Toggle navigation menu"
          aria-expanded={mobileMenuOpen}
        >
          <span className="hamburger-icon">☰</span>
        </button>
        
        <Link to="/" className="logo">
          <img src={logo} alt="Aashman Technicals Pvt Ltd" />
          <strong><span>Aashman Technicals Pvt Ltd</span></strong>
        </Link>
        
        <nav ref={navRef} className={mobileMenuOpen ? 'mobile-menu-open' : ''}>
          <Link to="/" className={`nav-link ${isActive('/')}`} onClick={handleNavClick}>
            🏠 Home
          </Link>
          <Link to="/about" className={`nav-link ${isActive('/about')}`} onClick={handleNavClick}>
            ℹ️ About
          </Link>
          <Link to="/services" className={`nav-link ${isActive('/services')}`} onClick={handleNavClick}>
            ⚙️ Services
          </Link>
          <Link to="/products" className={`nav-link ${isActive('/products')}`} onClick={handleNavClick}>
            📦 Products
          </Link>
          <Link to="/help" className={`nav-link ${isActive('/help')}`} onClick={handleNavClick}>
            👨‍🔧 Help
          </Link>
          <Link to="/contact" className={`nav-link ${isActive('/contact')}`} onClick={handleNavClick}>
            📧 Contact
          </Link>
        </nav>
      </div>
    </header>
  );
}

export default Header;